import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const useCopy = (defaultValue: boolean, timeout: number): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [copied, setCopied] = useState(defaultValue);
  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(!copied);
      }, timeout);
    }
  }, [copied]);

  return [copied, setCopied];
};
